import type { ChartRange } from "../api/types";

interface RangeTabsProps {
  ranges: ChartRange[];
  activeRange: string;
  onSelect: (range: string) => void;
}

export function RangeTabs({ ranges, activeRange, onSelect }: RangeTabsProps) {
  return (
    <div className="range-tabs" role="tablist" aria-label="Chart range">
      {ranges.map((range) => {
        const isActive = range.key === activeRange;
        return (
          <button
            key={range.key}
            type="button"
            role="tab"
            className={`range-button${isActive ? " is-active" : ""}`}
            aria-selected={isActive}
            onClick={() => onSelect(range.key)}
          >
            {range.label}
          </button>
        );
      })}
    </div>
  );
}
